import { z } from 'zod'

export const AutomatedAssignmentRegionOverrideZod = z.object({
  haversineDistanceEstimation: z
    .object({
      meterToMinutes: z.number().nullish(),
      constant: z.number().nullish(),
    })
    .nullish(),
  distanceMatrixComputationThreshold: z
    .object({
      preSolverRealDistanceCandidatesCount: z.number().nonnegative().nullish(),
    })
    .nullish(),
})

export const ConfigurationAutomatedAssignmentZod = z.object({
  runGlobalAssignments: z.boolean().optional().default(true),
  maximumIterationCount: z.number().nonnegative().optional().default(20),
  teamWaitTimeBeforeAssignment: z.number().nonnegative().optional().default(0),
  maximumCostThreshold: z.number().nonnegative().optional().default(1000),
  teamGeolocationExpirationDelay: z.number().nonnegative().optional().default(5),
  teamGeolocationFutureTolerance: z.number().nonnegative().optional().default(5),
  teamOnBreakAvailability: z.number().nonnegative().optional().default(15),
  teamPickupClientCost: z.number().nonnegative().optional().default(15),
  distanceMatrixComputationThreshold: z
    .object({
      teamAvailabilityTime: z.number().optional().default(5),
      distanceInMetersFromRequestPosition: z.number().optional().default(1000),
      preSolverRealDistanceCandidatesCount: z.number().nonnegative().optional().default(2),
    })
    .optional()
    .default({}),
  haversineDistanceEstimation: z
    .object({
      meterToMinutes: z.number().optional().default(1),
      constant: z.number().optional().default(0),
    })
    .optional()
    .default({}),
  realDistanceConstant: z.number().nullish().default(0),
  distanceCost: z
    .object({
      quadraticMultiplier: z.number().optional().default(0),
      linearMultiplier: z.number().optional().default(1),
      constant: z.number().optional().default(0),
    })
    .optional()
    .default({}),
  availabilityWaitTimeCost: z
    .object({
      quadraticMultiplier: z.number().optional().default(0),
      linearMultiplier: z.number().optional().default(1),
      constant: z.number().optional().default(0),
    })
    .optional()
    .default({}),
  teamIdleTimeBonus: z
    .object({
      firstAssignmentBonus: z.number().optional().default(15),
      teamWaitTimeBonus: z.number().optional().default(20),
      coefficient: z.number().optional().default(15),
    })
    .optional()
    .default({}),
  transportRequestWaitTimeBonus: z
    .object({
      quadraticMultiplier: z.number().optional().default(0),
      linearMultiplier: z.number().optional().default(1),
      constant: z.number().optional().default(0),
    })
    .optional()
    .default({}),
  penalty: z
    .object({
      manualTransmissionTeamNotRequired: z.number().nonnegative().optional().default(0),
      teamAvailableInInstitution: z.number().nonnegative().optional().default(0),
      teamAvailableInLocation: z.number().nonnegative().optional().default(0),
      teamAvailableInRegion: z.number().nonnegative().optional().default(0),
      teamEstimatedAvailabilityWithoutGeolocation: z.number().nonnegative().optional().default(0),
      teamNotInSameLocation: z.number().nonnegative().optional().default(0),
      teamOutdatedGeolocation: z.number().nonnegative().nullish().default(0),
    })
    .optional()
    .default({}),
  regionOverrides: z.record(z.string(), AutomatedAssignmentRegionOverrideZod).nullish().default({}),
})
